import React, { Component } from "react";
import { SwipeableDrawer } from "@material-ui/core";
import { connect } from "react-redux";

import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Style from "react-style-tag/lib/Style";

class WaitList extends Component {
  state = {
    selectedBranchDeliveryCharge: null,
    selectOpen: window.location.hostname?.includes("rajuandson") ? true : false,
  };

  componentDidMount = () => {
    const { branchDeliveryCharges, deliveryCharge, savedBDC } = this.props;
    // If the user previously selected an area (branch delivery charge), set it as default
    if (
      savedBDC &&
      branchDeliveryCharges.find((bdc) => bdc.id == savedBDC) &&
      branchDeliveryCharges.find((bdc) => bdc.id == savedBDC).delivery_charge ==
        deliveryCharge
    ) {
      this.setState({ selectedBranchDeliveryCharge: savedBDC });
    } else {
      // Find branch delivery charges with the same delivery charge and take the first one as default
      const firstBranchDeliveryCharge = branchDeliveryCharges.filter(
        (bdc) => bdc.delivery_charge == deliveryCharge
      )[0].id;
      this.setState({
        selectedBranchDeliveryCharge: firstBranchDeliveryCharge,
      });
    }
  };

  compare(a, b) {
    if (a.branch_sort_order < b.branch_sort_order) {
      return -1;
    }
    if (a.branch_sort_order > b.branch_sort_order) {
      return 1;
    }
    return 0;
  }

  render() {
    const {
      branchDeliveryCharges,
      deliveryCharge,
      onClose,
      handleContinue,
      language,
    } = this.props;

    // Find all branch delivery charges with the same delivery charge from the parent, and create select options with branch names
    let bdcs = branchDeliveryCharges
      .sort(this.compare)
      .filter((bdc) => bdc.delivery_charge == deliveryCharge)
      .map((bdc) => (
        <MenuItem
          value={bdc.id}
          component="div"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          <div style={{ lineHeight: bdc.branch_is_busy ? 1.5 : 2.5 }}>
            {language === "english" ? bdc.branch_name : bdc.branch_name_ar}
          </div>
          <div>
            {bdc.branch_is_busy && bdc.allow_preordering && (
              <span style={{ color: "orange", fontSize: 12 }}>
                {language === "arabic"
                  ? "مشغول - اطلب مسبقا"
                  : "Busy - Order for later"}
              </span>
            )}
            {bdc.branch_is_busy && !bdc.allow_preordering && (
              <span style={{ color: "red", fontSize: 12 }}>
                {language === "arabic" ? "مغلق" : "Closed"}
              </span>
            )}
          </div>
        </MenuItem>
      ));
    return (
      <div className="w-100">
        <Style>
          {`.MuiListItem-root {
                  display: block !important;
              }`}
        </Style>
        <SwipeableDrawer
          anchor="bottom"
          open={true}
          onClose={() => onClose()}
          PaperProps={{
            style: { minHeight: 225, height: "auto" },
            className: "text-center w-100",
          }}
          onBackdropClick={() => onClose()}
        >
          <div>
            <span
              style={{
                position: "absolute",
                top: 15,
                right: language == "english" && 15,
                left: language == "arabic" && 15,
              }}
            >
              <CloseIcon
                onClick={() => onClose()}
                style={{ color: "#565656" }}
              />
            </span>
            <h2
              className={"mx-auto ".concat(
                language == "english" ? "text-left" : "text-right"
              )}
              style={{ width: "90%", marginTop: 25, fontSize: "1.2rem" }}
            >
              {language == "english" ? "Select a branch" : "اختر فرع"}
            </h2>

            <Select
              className=" mb-3 w-75"
              defaultValue={this.state.selectedBranchDeliveryCharge}
              value={this.state.selectedBranchDeliveryCharge}
              onChange={(e) =>
                this.setState({ selectedBranchDeliveryCharge: e.target.value })
              }
              style={{ top: 23 }}
              open={this.state.selectOpen}
              onClose={() => this.setState({ selectOpen: false })}
              onOpen={() => this.setState({ selectOpen: true })}
            >
              {bdcs}
            </Select>
            <Button
              className="mt-2 mb-1"
              variant="contained"
              color="primary"
              style={{
                width: "92%",
                height: 50,
                position: "absolute",
                bottom: 15,
                left: 0,
                right: 0,
                margin: "auto",
              }}
              disableElevation
              onClick={() =>
                handleContinue(this.state.selectedBranchDeliveryCharge)
              }
            >
              {language == "english" ? "Continue" : "إكمال"}
            </Button>
          </div>
        </SwipeableDrawer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    branchDeliveryCharges: state.store.store.branch_delivery_charges,
    language: state.store.language,
    savedBDC: state.branch.bdc,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WaitList);
